import EventEdition from './EventEdition';

export default EventEdition;
